import { dateformat } from '../../../helpers';
import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_ASISTENCIAS_DIARIAS = 'ALL_ASISTENCIAS_DIARIAS';
export const LOADING_ALL_ASISTENCIAS_DIARIAS =
  'LOADING_ALL_ASISTENCIAS_DIARIAS';
export const ACTIVO_ASISTENCIAS_DIARIAS = 'ACTIVO_ASISTENCIAS_DIARIAS';
export const PARAMS_ASISTENCIAS_DIARIAS = 'PARAMS_ASISTENCIAS_DIARIAS';
export const PLANEVA_ASISTENCIAS_DIARIAS = 'PLANEVA_ASISTENCIAS_DIARIAS';
export const ALL_ESTUDIANTES_ASISTENCIAS_DIARIAS =
  'ALL_ESTUDIANTES_ASISTENCIAS_DIARIAS';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  planEvaluacion: null,
  pagination: {
    currentPage: 1,
    itemCount: 1,
    itemsPerPage: 50,
    totalItems: 1,
    totalPages: 1,
  },
  params: {
    q: null,
    orders: null,
    desde: dateformat(null, {}),
    hasta: dateformat(null, {}),
    page: 1,
    limit: 50,
  },
  allEstudiantesAsistencias: [],
  setIsDisabledAsistencia: false,
};

export const asistenciasReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_ASISTENCIAS_DIARIAS:
      return {
        ...state,
        all: action.payload.data,
        pagination: action.payload.meta,
      };
    case ACTIVO_ASISTENCIAS_DIARIAS:
      return {
        ...state,
        activo: action.payload,
      };
    case PLANEVA_ASISTENCIAS_DIARIAS:
      return {
        ...state,
        planEvaluacion: action.payload,
      };
    case LOADING_ALL_ASISTENCIAS_DIARIAS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case PARAMS_ASISTENCIAS_DIARIAS:
      return {
        ...state,
        params: action.payload,
      };
    case ALL_ESTUDIANTES_ASISTENCIAS_DIARIAS:
      return {
        ...state,
        allEstudiantesAsistencias: action.payload,
      };

    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
